import React, { useContext, useState, useEffect } from "react";
import { List, ListItem, ListItemText, ListItemIcon, Divider, Card, CardContent, Modal, Select, MenuItem, FormControl, InputLabel, Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Col, Form, Row } from "react-bootstrap";
import {
    getFileLiveUrl,
    MOB_ICONS,
    momentDate,
    sleep,
    upperCase,
    baseUrl,
} from "../../utils";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import PsContext from "../../context";
import Typography from "@mui/material/Typography";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";

const PersonalDetail = (props) => {
    const context = useContext(PsContext);
    const [showDetails, setShowDetails] = useState(false);
    const [showProgramDetails, setShowProgramDetails] = useState(false);
    const [showFamilyDetails, setShowFamilyDetails] = useState(false);
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [template, setTemplate] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState('');

    useEffect(() => {
    }, []);

    const toggleDetails = () => setShowDetails(!showDetails);
    const toggleProgramDetails = () => setShowProgramDetails(!showProgramDetails);
    const toggleFamilyDetails = () => setShowFamilyDetails(!showFamilyDetails);
    const toggleBankDetails = () => setShowBankDetails(!showBankDetails);

    const loadTemplate = () => {
        context.setLoader(true);
        axios.post(ServiceUrl.MOB.LIST_STAFF_TEMPLATE).then((res) => {
            if (res["data"].status === "1") {
                setTemplate(res["data"].data);
                setModalOpen(true);
                console.log('Templates fetched:', res["data"].data);
            } else {
                Toast.show({ content: res["data"].message || "Error" });
            }
            context.setLoader(false);
        });
    };

    const userPhoto = () => {
        if (
            props.dataSource &&
            props.dataSource.emp_profile_photo &&
            props.dataSource.emp_profile_photo.length > 5
        )
            return getFileLiveUrl(props.dataSource.emp_profile_photo);

        let gender = upperCase(props.dataSource.emp_gender);
        if (gender == "MALE") return MOB_ICONS.MAN_256;
        else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
    };

    const handleTemplateChange = (event) => {
        setSelectedTemplate(event.target.value);
    };

    const downloadFile = (id, temp_id) => {
        const link = `${baseUrl}mob/v1/employeereport?q=${id}&temp_id=${temp_id}`;
        var a = document.createElement("a");
        a.setAttribute("download", id);
        a.setAttribute("href", link);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div className="container-sm py-md-3" style={{ background: "linear-gradient(to bottom, #E6F7FE, #FFFFFF" }}>

            <Row>
                <Card sx={{ display: "flex", padding: "10px", alignItems: "center" }} className="card-header-bg text-uppercase fw-bold">
                    <CardMedia
                        component="img"
                        sx={{ width: 100, borderRadius: '50%' }}
                        src={userPhoto()}
                    />
                    <Box className="ms-2" sx={{ display: "flex", flexDirection: "column", marginLeft: "16px" }}>
                        <CardContent>
                            <Typography variant="h5" className="fw-bolder" style={{ fontSize: "20px" }}>
                                {props.dataSource.emp_name}
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontSize: "14px" }}>
                                {props.dataSource.designation_name}
                            </Typography>
                            <Typography variant="subtitle2" style={{ fontSize: "12px", color: "#757575" }}>
                                {props.dataSource.emp_personal_mail}
                            </Typography>
                        </CardContent>
                    </Box>
                </Card>
            </Row>

            <List>
                <ListItem button onClick={toggleDetails}>
                    <ListItemIcon>
                        <PersonIcon variant="contained"
                            color="primary"
                            size='sm' />
                    </ListItemIcon>
                    <ListItemText primary="Personal Information" variant="contained"
                        color="primary"
                        size='sm' />
                    <ArrowForwardIosIcon variant="contained"
                        color="primary"
                        size='sm' />
                </ListItem>
                <Divider />
                {showDetails && (
                    <Row className="mt-3">
                        <Col xs={12}>
                            <Card>
                                <CardContent>
                                    <div className="p-2">
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Name</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>DOB</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {momentDate(props.dataSource.emp_dob, "DD-MMM-YYYY")}

                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Gender</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_gender}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Email</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_personal_mail}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Mobile</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_personal_mobile}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Address</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_current_address}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Religion</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_religion}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Caste</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_caste}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Community</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_community}
                                            </Col>
                                        </Row>
                                    </div>
                                </CardContent>
                            </Card>
                        </Col>
                    </Row>
                )}

                <ListItem button onClick={toggleProgramDetails}>
                    <ListItemIcon>
                        <WorkIcon variant="contained"
                            color="primary"
                            size='sm' />
                    </ListItemIcon>
                    <ListItemText primary="Program Details" variant="contained"
                        color="primary"
                        size='sm' />
                    <ArrowForwardIosIcon variant="contained"
                        color="primary"
                        size='sm' />
                </ListItem>
                <Divider />
                {showProgramDetails && (
                    <Row className="mt-3">
                        <Col xs={12}>
                            <Card>
                                <CardContent>
                                    <div className="p-2">
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Department</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.department_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Qualification</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_qualification}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Qualification Category</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_qualification_category}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Designation</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.designation_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Type</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_employee_type1}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Category</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_employee_category}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Academic Department</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_academic_department}
                                            </Col>
                                        </Row>
                                    </div>
                                </CardContent>
                            </Card>
                        </Col>
                    </Row>
                )}
                <ListItem button onClick={toggleFamilyDetails}>
                    <ListItemIcon>
                        <FamilyRestroomIcon variant="contained"
                            color="primary"
                            size='sm' />
                    </ListItemIcon>
                    <ListItemText primary="Family Details" />
                    <ArrowForwardIosIcon variant="contained"
                        color="primary"
                        size='sm' />
                </ListItem>
                <Divider />
                {showFamilyDetails && (
                    <Row className="mt-3">
                        <Col xs={12}>
                            <Card>
                                <CardContent>
                                    <div className="p-2">
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Married</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_marital_status === 1 ? "Married" : "Unmarried"}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Aadhar No </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_aadhar}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Spouse Name </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_spouse_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Anniversary</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_anniversary}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Father's Name</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_father_name}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Mother's Name</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_mother_name}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Present Address</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_current_address}-{props.dataSource.emp_current_city}{props.dataSource.emp_current_pincode}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Employee Permanent Address</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_permanent_address}{props.dataSource.emp_permanent_city}{props.dataSource.emp_permanent_pincode}
                                            </Col>
                                        </Row>
                                    </div>
                                </CardContent>
                            </Card>
                        </Col>

                    </Row>
                )}

                <ListItem button onClick={toggleBankDetails}>
                    <ListItemIcon>
                        <AccountBalanceIcon variant="contained"
                            color="primary"
                            size='sm' />
                    </ListItemIcon>
                    <ListItemText primary="Bank Details" variant="contained"
                        color="primary"
                        size='sm' />
                    <ArrowForwardIosIcon variant="contained"
                        color="primary"
                        size='sm' />
                </ListItem>
                <Divider />
                {showBankDetails && (
                    <Row className="mt-3">
                        <Col xs={12}>
                            <Card>
                                <CardContent>
                                    <div className="p-2">
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Bank Name </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_bank_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Bank Branch Name</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_bank_branch_name}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>Bank Account No</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_bank_account_no}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>IFSC Code</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_ifsc_code}
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>PAN No</strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_pan_card_no}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>EPF Joint Date  </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {momentDate(props.dataSource.emp_epf_join_date, "DD-MMM-YYYY")}

                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>PF No </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_epf_no}
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <Col xs={5}>
                                                <strong>ESI No </strong>
                                            </Col>
                                            <Col xs={7}>
                                                {props.dataSource.emp_esi_no}
                                            </Col>
                                        </Row>
                                    </div>
                                </CardContent>
                            </Card>
                        </Col>

                    </Row>
                )}

                <Row className="mt-3">
                    <Col xs={12}>
                        <div
                            onClick={loadTemplate}
                            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', cursor: 'pointer' }}
                        >
                            <span>Download more details</span>
                            <ArrowForwardIcon sx={{ marginLeft: '10px' }} />
                        </div>
                    </Col>
                </Row>

                <Modal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    aria-labelledby="select-template-modal"
                    aria-describedby="modal-for-selecting-template"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '300px',
                            bgcolor: 'background.paper',
                            borderRadius: '8px',
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <h5 id="select-template-modal">Select Template</h5>
                        <FormControl fullWidth variant="outlined" style={{ marginBottom: '20px' }}>
                            <InputLabel id="template-select-label">Report</InputLabel>
                            <Select
                                labelId="template-select-label"
                                value={selectedTemplate}
                                onChange={handleTemplateChange}
                                label="Choose Template"
                            >
                                {template.map((temp) => (
                                    <MenuItem key={temp.id} value={temp.id}>
                                        {temp.certificate_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button variant="contained" color="primary" onClick={() => {
                            const id = props.dataSource.id;
                            const temp_id = selectedTemplate;
                            downloadFile(id, temp_id);
                            setModalOpen(false);
                        }}>
                            Confirm
                        </Button>
                        <Button variant="outlined" onClick={() => setModalOpen(false)} style={{ marginLeft: '10px' }}>
                            Cancel
                        </Button>
                    </Box>
                </Modal>

            </List>
        </div>



    );
};

export default PersonalDetail;
